import React from "react";

import { SearchInput } from "./search-input";
import { StatusFilters } from "./filters/status-filters";
import { DateFilters } from "./filters/date-filters";
import { Filters } from "./filters/filters";
import { EncounterFilterStatus } from "../types";

interface EncounterFiltersProps {
    searchValue: string;
    setSearchValue: (value: string) => void;
    filter: string;
    setFilter: React.Dispatch<React.SetStateAction<string>>;
    date: string;
    setDate: React.Dispatch<React.SetStateAction<string>>;
    // status: string;
    status: EncounterFilterStatus;
    setStatus: React.Dispatch<React.SetStateAction<EncounterFilterStatus>>;
    // setStatus: React.Dispatch<React.SetStateAction<string>>;
}

export const EncounterFilters = ({ searchValue, setSearchValue, setDate, date, setFilter, filter, status, setStatus }: EncounterFiltersProps) => {
    return (
        <div className="flex flex-col md:flex-row items-center justify-between w-full mt-[16px] gap-[16px] h-fit">
            <SearchInput
                value={searchValue}
                setValue={setSearchValue}
                placeholder="Search by patient or email"
                className=""
            />

            <div className="flex flex-row items-center gap-[16px] justify-start md:justify-end w-full md:w-auto h-fit">
               
                <StatusFilters status={status} setStatus={setStatus} />
                <DateFilters date={date} setDate={setDate} />
                 <Filters filter={filter} setFilter={setFilter} />
            </div>
        </div>
    );
};

